/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { isBrowser, isMobile } from 'react-device-detect';
import { useSetting } from '../../utilities/sharedHooks/settings';

const Maintenance = () => {
  const { t: translate } = useTranslation();

  const [ledgerSupportEmailAddress] = useSetting('server_configurations', 'support_email_address');

  return (
    <div
      className={`h-100vh w-100 bg-maintenance py-2 ${isMobile ? 'px-3' : ''}`}
      style={{
        paddingLeft: isBrowser ? '5.625rem' : '',
        paddingRight: isBrowser ? '5.625rem' : '',
      }}>
      <div className={`flex flex-row ${isMobile ? 'ps-3' : 'ps-5'}`}>
        <img
          style={{ width: '6rem', height: 'auto' }}
          className="logo mb-1"
          src="./assets/images/logo-black.svg"
          alt="Logo"
        />
      </div>
      <div className="d-flex flex-column align-items-center mt-2">
        <div className="">
          <img
            style={{ width: isBrowser ? '25rem' : '100%', height: 'auto' }}
            className="logo mb-1"
            src="./assets/images/maintenance.png"
            alt="Logo"
          />
        </div>
        <p
          className="text-black mt-5 maintenance-title upper-case text-center"
          style={{ fontSize: isBrowser ? '2.875rem' : '2rem' }}>
          {translate('maintenance_title')}
        </p>
        <p className="text-f5 text-black text-center mt-3">{translate('maintenance_note_1')}</p>
        <p className="text-f5 text-black">{translate('maintenance_note_2')}</p>
        <p className="text-f6 text-black text-center mt-5">
          <Trans
            i18nKey="maintenance_contact_support"
            values={{
              support_email: ledgerSupportEmailAddress,
            }}
            components={[
              <a
                key="contact-link-2"
                className="text-decoration-none"
                href={`mailto:${ledgerSupportEmailAddress}`}
                rel="noreferrer"
              />,
            ]}
          />
        </p>
      </div>
    </div>
  );
};

export default Maintenance;
